/* istanbul ignore file */
import React, { FC, MouseEventHandler, ReactNode } from 'react';

export interface TabProps {
  /** Name of the tab, useful to select a tab by nam instead of its index. */
  name?: string;
  /** Title of the tab. */
  title?: ReactNode;
  /** Disables the tab. */
  disabled?: boolean;
  /** Tabindex of the tab for keyboard navigation. */
  tabIndex?: string;
  /** Indicates that this tab should always be rendered. */
  forceRender?: boolean;
  /** Content of the tab. */
  children?: ReactNode;
  /** On click handler when selecting the . */
  onClick?: MouseEventHandler<HTMLLIElement>;
}

/**
 * @mode developer
 */
const Tab: FC<TabProps> & { type: Symbol } = ({ children }) => <>{children}</>;

Tab.type = Symbol('Tab');

export default Tab;
